export const fontWeights = {
  light: 200,
  normal: 400,
  medium: 500,
  bold: 600,
  bolder: 700,
  boldest: 900,
} as const
